<template>
  <div class="l-body">
    <Top/>
    <div class="wrap news_bg">
      <div class="news-jl-box_ls">
        <div class="ls-wrap zheng">
          <div class="news_list_tit">
            <h1>客服新闻/<span>NEWS</span></h1>
            <h2>当前位置：<a href="/">首页</a> > <a @click="$router.push({path:'/newslist'})">新闻中心</a> > <a>新闻正文</a></h2>
          </div>
          <div class="news_zhengwen" v-for="news in newsData">
            <h1>{{news.title}}</h1>
            <h2>发布时间：{{news.time}}</h2>
            <div class="news_zw" v-html="news.content">
            </div>
          </div>
          <div class="fenxiang">
            <div class="fendaima">
              <div class="bshare-custom">
                <span class="fx_span">分享到：</span>
                <div class="bdsharebuttonbox jiathis_style_32x32">
                  <a href="#" class="bds_qzone" data-cmd="qzone" title="分享到QQ空间"></a>
                  <a href="#" class="bds_tsina" data-cmd="tsina" title="分享到新浪微博"></a>
                  <a href="#" class="bds_renren" data-cmd="renren" title="分享到人人网"></a>
                  <a href="#" class="bds_tqq" data-cmd="tqq" title="分享到腾讯微博"></a>
                </div>
              </div>
            </div>
            <div class="banquan">塔人网络</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //window._bd_share_config={"common":{"bdPic" : "0618/fenxiang.jpg","bdSize": "24"},"share":{}};
  //with(document)0[(getElementsByTagName('head')[0]||body).appendChild(createElement('script')).src='http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion='+~(-new Date()/36e5)];
  import Top from '@/components/top.vue'
  export default {
    name: "news",
    components: {
      Top
    },
    data () {
      return {
        id:this.$route.query.id,
        newsData:[]
      }
    },
    created() {
      this.getNews()
    },
    methods:{
      getNews() {
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/newsinfo',
          params: {
            id: this.id
          }
        }).then(res => {
          if (res.data.status == 200) {
            this.newsData .push({
              "title" : res.data.data.title,
              "content" : res.data.data.content,
              "time" : res.data.data.time
            });
          } else {
            this.newsData = []
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/news.vue